import { configureStore, combineReducers } from "@reduxjs/toolkit";
import { apiSlice } from "./api/apiSlice";
import authSlice from "../features/auth/authSlice";
import { useEffect } from "react";

const allReducers = combineReducers({
  auth: authSlice,
  [apiSlice.reducerPath]: apiSlice.reducer,
});

export const store = configureStore({
  reducer: allReducers,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      immutableCheck: false,
      serializable: false,
    }).concat(apiSlice.middleware),
  devTools: true,
});

store.asyncReducers = {};

export const useInjectReducer = (key, asyncReducers) => {
  useEffect(() => {
    if (!asyncReducers) {
      throw new Error("Entry is not a valid reducer.");
    }
    if (store.asyncReducers[key] !== undefined) {
      return;
    }

    function createReducer(asyncReducers) {
      return combineReducers({
        auth: authSlice,
        [apiSlice.reducerPath]: apiSlice.reducer,
        ...asyncReducers,
      });
    }

    store.asyncReducers[key] = asyncReducers;
    store.replaceReducer(createReducer(store.asyncReducers));
  }, [key, asyncReducers]);
};

// for React-testing-library
export const setupStore = (preloadedState) => {
  return configureStore({
    reducer: allReducers,
    preloadedState,
  });
};
